"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAudioContext = function () {
    window.AudioContext =
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.AudioContext || window.webkitAudioContext;
    return new AudioContext();
};
